import { Soundfont, useAudioEngine, useInstrument, type InstrumentName } from '@tunasong/audio-ui'
import { type NoteEvent } from '@tunasong/music-lib'
import { useMemo } from 'react'

/** Hook to provide MIDI integration for keyboards */
export const usePlayNotes = (instrumentName: InstrumentName = 'acoustic_grand_piano') => {
  const engine = useAudioEngine()

  const baseInstrument = useMemo(
    () => new Soundfont(engine.mixer.context, instrumentName),
    [engine.mixer.context, instrumentName]
  )
  /**
   * Route to *this* hook's instrument. `engine.play(notes)` with no id resolves to
   * `Object.keys(instruments)[0]` — the first instrument registered on the page — so two hooks
   * with two different instruments would both sound as whichever mounted first. `undefined`
   * while the registration effect is still pending keeps the old fallback, so an early click
   * still makes a sound. @see useInstrument
   */
  const instrumentId = useInstrument('base', baseInstrument) ?? undefined

  const playNotes = (notes: NoteEvent[]) => {
    engine.play(notes, instrumentId)
  }
  const playNoteSequence = (notes: NoteEvent[]) => {
    engine.playSequence(notes, instrumentId)
  }

  return { playNotes, playNoteSequence }
}
